export default __webpack_public_path__ + "static/media/article4.6b7519b1.png";